// API Keys panel translations (Profile → API Keys section)
export const apiKeysTranslations = {
  en: {
    title: "API Keys",
    description: "Create personal API keys to use QualiTaTi from scripts or AI agents (such as the MCP server). A key acts as you and draws on your quota.",
    docsLink: "Read the API & MCP docs →",
    createBtn: "Create API key",
    empty: "You don't have any API keys yet.",
    thName: "Name",
    thKey: "Key",
    thCreated: "Created",
    thLastUsed: "Last used",
    thStatus: "Status",
    thActions: "Actions",
    active: "Active",
    revoked: "Revoked",
    expired: "Expired",
    never: "Never",
    revoke: "Revoke",
    createTitle: "Create API key",
    nameLabel: "Name (optional)",
    namePlaceholder: "e.g. MCP server",
    expiryLabel: "Expires in days (optional)",
    create: "Create",
    creating: "Creating…",
    cancel: "Cancel",
    createdTitle: "API key created",
    createdWarning: "Copy this key now. For your security, it won't be shown again.",
    copy: "Copy",
    copied: "Copied!",
    close: "Done",
    revokeTitle: "Revoke this API key?",
    revokePrompt: "Any script or agent using this key will immediately lose access. This can't be undone.",
    revoking: "Revoking…",
    confirmRevoke: "Revoke",
    errLoad: "Could not load your API keys.",
    errCreate: "Could not create the API key.",
    errRevoke: "Could not revoke the API key."
  },
  zh: {
    title: "API 密钥",
    description: "创建个人 API 密钥，以便通过脚本或 AI 智能体（例如 MCP 服务器）使用 QualiTaTi。密钥代表您本人，并占用您的额度。",
    docsLink: "查看 API 与 MCP 文档 →",
    createBtn: "创建 API 密钥",
    empty: "您还没有任何 API 密钥。",
    thName: "名称",
    thKey: "密钥",
    thCreated: "创建时间",
    thLastUsed: "最近使用",
    thStatus: "状态",
    thActions: "操作",
    active: "有效",
    revoked: "已吊销",
    expired: "已过期",
    never: "从未",
    revoke: "吊销",
    createTitle: "创建 API 密钥",
    nameLabel: "名称（可选）",
    namePlaceholder: "例如：MCP 服务器",
    expiryLabel: "有效天数（可选）",
    create: "创建",
    creating: "创建中…",
    cancel: "取消",
    createdTitle: "API 密钥已创建",
    createdWarning: "请立即复制此密钥。出于安全考虑，它不会再次显示。",
    copy: "复制",
    copied: "已复制！",
    close: "完成",
    revokeTitle: "吊销此 API 密钥？",
    revokePrompt: "任何使用此密钥的脚本或智能体将立即失去访问权限。此操作无法撤销。",
    revoking: "吊销中…",
    confirmRevoke: "吊销",
    errLoad: "无法加载您的 API 密钥。",
    errCreate: "无法创建 API 密钥。",
    errRevoke: "无法吊销 API 密钥。"
  },
  fr: {
    title: "Clés API",
    description: "Créez des clés API personnelles pour utiliser QualiTaTi depuis des scripts ou des agents IA (comme le serveur MCP). Une clé agit en votre nom et puise dans votre quota.",
    docsLink: "Consulter la documentation API et MCP →",
    createBtn: "Créer une clé API",
    empty: "Vous n'avez encore aucune clé API.",
    thName: "Nom",
    thKey: "Clé",
    thCreated: "Créée le",
    thLastUsed: "Dernière utilisation",
    thStatus: "Statut",
    thActions: "Actions",
    active: "Active",
    revoked: "Révoquée",
    expired: "Expirée",
    never: "Jamais",
    revoke: "Révoquer",
    createTitle: "Créer une clé API",
    nameLabel: "Nom (facultatif)",
    namePlaceholder: "ex. serveur MCP",
    expiryLabel: "Expire dans (jours, facultatif)",
    create: "Créer",
    creating: "Création…",
    cancel: "Annuler",
    createdTitle: "Clé API créée",
    createdWarning: "Copiez cette clé maintenant. Pour votre sécurité, elle ne sera plus affichée.",
    copy: "Copier",
    copied: "Copié !",
    close: "Terminé",
    revokeTitle: "Révoquer cette clé API ?",
    revokePrompt: "Tout script ou agent utilisant cette clé perdra immédiatement l'accès. Cette action est irréversible.",
    revoking: "Révocation…",
    confirmRevoke: "Révoquer",
    errLoad: "Impossible de charger vos clés API.",
    errCreate: "Impossible de créer la clé API.",
    errRevoke: "Impossible de révoquer la clé API."
  },
  nb: {
    title: "API-nøkler",
    description: "Opprett personlige API-nøkler for å bruke QualiTaTi fra skript eller AI-agenter (som MCP-serveren). En nøkkel handler som deg og trekker fra kvoten din.",
    docsLink: "Les API- og MCP-dokumentasjonen →",
    createBtn: "Opprett API-nøkkel",
    empty: "Du har ingen API-nøkler ennå.",
    thName: "Navn",
    thKey: "Nøkkel",
    thCreated: "Opprettet",
    thLastUsed: "Sist brukt",
    thStatus: "Status",
    thActions: "Handlinger",
    active: "Aktiv",
    revoked: "Tilbakekalt",
    expired: "Utløpt",
    never: "Aldri",
    revoke: "Tilbakekall",
    createTitle: "Opprett API-nøkkel",
    nameLabel: "Navn (valgfritt)",
    namePlaceholder: "f.eks. MCP-server",
    expiryLabel: "Utløper om (dager, valgfritt)",
    create: "Opprett",
    creating: "Oppretter…",
    cancel: "Avbryt",
    createdTitle: "API-nøkkel opprettet",
    createdWarning: "Kopier denne nøkkelen nå. Av sikkerhetshensyn vises den ikke igjen.",
    copy: "Kopier",
    copied: "Kopiert!",
    close: "Ferdig",
    revokeTitle: "Tilbakekalle denne API-nøkkelen?",
    revokePrompt: "Alle skript eller agenter som bruker denne nøkkelen, mister umiddelbart tilgang. Dette kan ikke angres.",
    revoking: "Tilbakekaller…",
    confirmRevoke: "Tilbakekall",
    errLoad: "Kunne ikke laste API-nøklene dine.",
    errCreate: "Kunne ikke opprette API-nøkkelen.",
    errRevoke: "Kunne ikke tilbakekalle API-nøkkelen."
  },
  nl: {
    title: "API-sleutels",
    description: "Maak persoonlijke API-sleutels om QualiTaTi te gebruiken vanuit scripts of AI-agents (zoals de MCP-server). Een sleutel handelt namens u en gebruikt uw quota.",
    docsLink: "Lees de API- en MCP-documentatie →",
    createBtn: "API-sleutel maken",
    empty: "U heeft nog geen API-sleutels.",
    thName: "Naam",
    thKey: "Sleutel",
    thCreated: "Gemaakt",
    thLastUsed: "Laatst gebruikt",
    thStatus: "Status",
    thActions: "Acties",
    active: "Actief",
    revoked: "Ingetrokken",
    expired: "Verlopen",
    never: "Nooit",
    revoke: "Intrekken",
    createTitle: "API-sleutel maken",
    nameLabel: "Naam (optioneel)",
    namePlaceholder: "bijv. MCP-server",
    expiryLabel: "Verloopt over (dagen, optioneel)",
    create: "Maken",
    creating: "Maken…",
    cancel: "Annuleren",
    createdTitle: "API-sleutel gemaakt",
    createdWarning: "Kopieer deze sleutel nu. Om veiligheidsredenen wordt hij niet opnieuw getoond.",
    copy: "Kopiëren",
    copied: "Gekopieerd!",
    close: "Klaar",
    revokeTitle: "Deze API-sleutel intrekken?",
    revokePrompt: "Elk script of elke agent die deze sleutel gebruikt, verliest onmiddellijk de toegang. Dit kan niet ongedaan worden gemaakt.",
    revoking: "Intrekken…",
    confirmRevoke: "Intrekken",
    errLoad: "Kon uw API-sleutels niet laden.",
    errCreate: "Kon de API-sleutel niet maken.",
    errRevoke: "Kon de API-sleutel niet intrekken."
  },
  de: {
    title: "API-Schlüssel",
    description: "Erstellen Sie persönliche API-Schlüssel, um QualiTaTi aus Skripten oder KI-Agenten (wie dem MCP-Server) zu nutzen. Ein Schlüssel handelt in Ihrem Namen und nutzt Ihr Kontingent.",
    docsLink: "API- und MCP-Dokumentation lesen →",
    createBtn: "API-Schlüssel erstellen",
    empty: "Sie haben noch keine API-Schlüssel.",
    thName: "Name",
    thKey: "Schlüssel",
    thCreated: "Erstellt",
    thLastUsed: "Zuletzt verwendet",
    thStatus: "Status",
    thActions: "Aktionen",
    active: "Aktiv",
    revoked: "Widerrufen",
    expired: "Abgelaufen",
    never: "Nie",
    revoke: "Widerrufen",
    createTitle: "API-Schlüssel erstellen",
    nameLabel: "Name (optional)",
    namePlaceholder: "z. B. MCP-Server",
    expiryLabel: "Läuft ab in (Tagen, optional)",
    create: "Erstellen",
    creating: "Wird erstellt…",
    cancel: "Abbrechen",
    createdTitle: "API-Schlüssel erstellt",
    createdWarning: "Kopieren Sie diesen Schlüssel jetzt. Aus Sicherheitsgründen wird er nicht erneut angezeigt.",
    copy: "Kopieren",
    copied: "Kopiert!",
    close: "Fertig",
    revokeTitle: "Diesen API-Schlüssel widerrufen?",
    revokePrompt: "Jedes Skript oder jeder Agent, der diesen Schlüssel verwendet, verliert sofort den Zugriff. Dies kann nicht rückgängig gemacht werden.",
    revoking: "Wird widerrufen…",
    confirmRevoke: "Widerrufen",
    errLoad: "Ihre API-Schlüssel konnten nicht geladen werden.",
    errCreate: "Der API-Schlüssel konnte nicht erstellt werden.",
    errRevoke: "Der API-Schlüssel konnte nicht widerrufen werden."
  },
  es: {
    title: "Claves API",
    description: "Cree claves API personales para usar QualiTaTi desde scripts o agentes de IA (como el servidor MCP). Una clave actúa en su nombre y consume su cuota.",
    docsLink: "Leer la documentación de API y MCP →",
    createBtn: "Crear clave API",
    empty: "Aún no tiene ninguna clave API.",
    thName: "Nombre",
    thKey: "Clave",
    thCreated: "Creada",
    thLastUsed: "Último uso",
    thStatus: "Estado",
    thActions: "Acciones",
    active: "Activa",
    revoked: "Revocada",
    expired: "Caducada",
    never: "Nunca",
    revoke: "Revocar",
    createTitle: "Crear clave API",
    nameLabel: "Nombre (opcional)",
    namePlaceholder: "p. ej. servidor MCP",
    expiryLabel: "Caduca en (días, opcional)",
    create: "Crear",
    creating: "Creando…",
    cancel: "Cancelar",
    createdTitle: "Clave API creada",
    createdWarning: "Copie esta clave ahora. Por su seguridad, no se volverá a mostrar.",
    copy: "Copiar",
    copied: "¡Copiado!",
    close: "Listo",
    revokeTitle: "¿Revocar esta clave API?",
    revokePrompt: "Cualquier script o agente que use esta clave perderá el acceso de inmediato. Esto no se puede deshacer.",
    revoking: "Revocando…",
    confirmRevoke: "Revocar",
    errLoad: "No se pudieron cargar sus claves API.",
    errCreate: "No se pudo crear la clave API.",
    errRevoke: "No se pudo revocar la clave API."
  },
  pt: {
    title: "Chaves de API",
    description: "Crie chaves de API pessoais para usar a QualiTaTi a partir de scripts ou agentes de IA (como o servidor MCP). Uma chave age como você e consome sua cota.",
    docsLink: "Ler a documentação de API e MCP →",
    createBtn: "Criar chave de API",
    empty: "Você ainda não tem nenhuma chave de API.",
    thName: "Nome",
    thKey: "Chave",
    thCreated: "Criada",
    thLastUsed: "Último uso",
    thStatus: "Status",
    thActions: "Ações",
    active: "Ativa",
    revoked: "Revogada",
    expired: "Expirada",
    never: "Nunca",
    revoke: "Revogar",
    createTitle: "Criar chave de API",
    nameLabel: "Nome (opcional)",
    namePlaceholder: "ex.: servidor MCP",
    expiryLabel: "Expira em (dias, opcional)",
    create: "Criar",
    creating: "Criando…",
    cancel: "Cancelar",
    createdTitle: "Chave de API criada",
    createdWarning: "Copie esta chave agora. Por segurança, ela não será exibida novamente.",
    copy: "Copiar",
    copied: "Copiado!",
    close: "Concluído",
    revokeTitle: "Revogar esta chave de API?",
    revokePrompt: "Qualquer script ou agente que use esta chave perderá o acesso imediatamente. Isso não pode ser desfeito.",
    revoking: "Revogando…",
    confirmRevoke: "Revogar",
    errLoad: "Não foi possível carregar suas chaves de API.",
    errCreate: "Não foi possível criar a chave de API.",
    errRevoke: "Não foi possível revogar a chave de API."
  },
  ja: {
    title: "API キー",
    description: "スクリプトや AI エージェント（MCP サーバーなど）から QualiTaTi を利用するための個人用 API キーを作成します。キーはあなた自身として動作し、あなたのクォータを消費します。",
    docsLink: "API と MCP のドキュメントを読む →",
    createBtn: "API キーを作成",
    empty: "API キーはまだありません。",
    thName: "名前",
    thKey: "キー",
    thCreated: "作成日",
    thLastUsed: "最終使用",
    thStatus: "ステータス",
    thActions: "操作",
    active: "有効",
    revoked: "取り消し済み",
    expired: "期限切れ",
    never: "なし",
    revoke: "取り消す",
    createTitle: "API キーを作成",
    nameLabel: "名前（任意）",
    namePlaceholder: "例：MCP サーバー",
    expiryLabel: "有効日数（任意）",
    create: "作成",
    creating: "作成中…",
    cancel: "キャンセル",
    createdTitle: "API キーを作成しました",
    createdWarning: "このキーを今すぐコピーしてください。セキュリティのため、再表示されません。",
    copy: "コピー",
    copied: "コピーしました！",
    close: "完了",
    revokeTitle: "この API キーを取り消しますか？",
    revokePrompt: "このキーを使用しているスクリプトやエージェントは直ちにアクセスできなくなります。この操作は取り消せません。",
    revoking: "取り消し中…",
    confirmRevoke: "取り消す",
    errLoad: "API キーを読み込めませんでした。",
    errCreate: "API キーを作成できませんでした。",
    errRevoke: "API キーを取り消せませんでした。"
  },
  ar: {
    title: "مفاتيح API",
    description: "أنشئ مفاتيح API شخصية لاستخدام QualiTaTi من السكربتات أو وكلاء الذكاء الاصطناعي (مثل خادم MCP). يعمل المفتاح نيابةً عنك ويستهلك حصتك.",
    docsLink: "اقرأ وثائق API وMCP ←",
    createBtn: "إنشاء مفتاح API",
    empty: "ليس لديك أي مفاتيح API بعد.",
    thName: "الاسم",
    thKey: "المفتاح",
    thCreated: "تاريخ الإنشاء",
    thLastUsed: "آخر استخدام",
    thStatus: "الحالة",
    thActions: "الإجراءات",
    active: "نشط",
    revoked: "مُلغى",
    expired: "منتهٍ",
    never: "أبدًا",
    revoke: "إلغاء",
    createTitle: "إنشاء مفتاح API",
    nameLabel: "الاسم (اختياري)",
    namePlaceholder: "مثال: خادم MCP",
    expiryLabel: "ينتهي خلال (أيام، اختياري)",
    create: "إنشاء",
    creating: "جارٍ الإنشاء…",
    cancel: "إلغاء",
    createdTitle: "تم إنشاء مفتاح API",
    createdWarning: "انسخ هذا المفتاح الآن. لأمانك، لن يُعرض مرة أخرى.",
    copy: "نسخ",
    copied: "تم النسخ!",
    close: "تم",
    revokeTitle: "إلغاء مفتاح API هذا؟",
    revokePrompt: "أي سكربت أو وكيل يستخدم هذا المفتاح سيفقد الوصول فورًا. لا يمكن التراجع عن هذا الإجراء.",
    revoking: "جارٍ الإلغاء…",
    confirmRevoke: "إلغاء",
    errLoad: "تعذّر تحميل مفاتيح API الخاصة بك.",
    errCreate: "تعذّر إنشاء مفتاح API.",
    errRevoke: "تعذّر إلغاء مفتاح API."
  }
};
